var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebookSpecifics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.0830078C4.25363 0.0830078 0 4.35854 0 9.63195C0 14.4191 3.50867 18.3724 8.07975 19.0631V12.1624H5.72929V9.65264H8.07975V7.98237C8.07975 5.21715 9.42004 4.00364 11.7064 4.00364C12.8013 4.00364 13.3807 4.0856 13.6547 4.12221V6.31289H12.0951C11.1245 6.31289 10.7857 7.23835 10.7857 8.28077V9.65264H13.6301L13.2446 12.1624H10.7857V19.083C15.4225 18.4512 19 14.4661 19 9.63195C19 4.35854 14.7464 0.0830078 9.5 0.0830078Z",
    fill: "#112240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebookSpecifics);
export default __webpack_public_path__ + "static/media/icon-facebook-specifics.d4ad93c4.svg";
export { ForwardRef as ReactComponent };